export const costSections = [
  {
    key: "intro",
    bodyEn: [
      "Miami-Dade homeowners deal with salt air, humidity, and storm stress that wears out windows and doors fast. When something breaks, the first question is always cost. This guide covers real price ranges for the repair services we provide across Miami-Dade neighborhoods.",
      "All prices are starting ranges. Final pricing depends on the specific repair, parts needed, and conditions on-site. We confirm pricing by phone before scheduling and again before work begins."
    ],
    bodyEs: [
      "Los propietarios de casas en Miami-Dade enfrentan aire salino, humedad y estrés de tormentas que desgastan ventanas y puertas rápidamente. Cuando algo se rompe, la primera pregunta siempre es el costo. Esta guía cubre rangos de precios reales para los servicios de reparación que proporcionamos en vecindarios de Miami-Dade.",
      "Todos los precios son rangos iniciales. El precio final depende de la reparación específica, las partes necesarias y las condiciones en el sitio. Confirmamos los precios por teléfono antes de programar y nuevamente antes de comenzar el trabajo."
    ]
  },
  {
    key: "diagnostic",
    bodyEn: [
      "Our diagnostic call includes travel to your home in Miami-Dade, assessment of the problem, and a written quote for the repair. If you proceed with the repair, the diagnostic fee is applied to the total. This is our most common starting point for homeowners who are not sure what is wrong.",
      "We can often diagnose by phone or photo for simpler issues, saving the diagnostic fee entirely. Call (786) 377-4452 to describe the issue."
    ],
    bodyEs: [
      "Nuestra visita de diagnóstico incluye el traslado a su casa en Miami-Dade, evaluación del problema y una cotización escrita para la reparación. Si procede con la reparación, la tarifa de diagnóstico se aplica al total. Este es nuestro punto de partida más común para propietarios que no están seguros de qué está mal.",
      "Frecuentemente podemos diagnosticar por teléfono o foto para problemas más simples, ahorrando completamente la tarifa de diagnóstico. Llame al (786) 377-4452 para describir el problema."
    ]
  },
  {
    key: "hardware",
    bodyEn: [
      "Hardware repairs cover rollers, locks, handles, hinges, and cranks. The exact price depends on the part and how many windows need work. Single window lock replacement starts around $120. Full roller and track service on a large sliding door can run $220 – $280."
    ],
    bodyEs: [
      "Las reparaciones de herrajes cubren rodillos, cerraduras, manijas, bisagras y manivelas. El precio exacto depende de la pieza y cuántas ventanas necesitan trabajo. El reemplazo de una cerradura individual comienza alrededor de $120. El servicio completo de rodillos y rieles en una puerta corrediza grande puede costar $220 – $280."
    ]
  },
  {
    key: "glass",
    bodyEn: [
      "We replace glass in existing frames only. We do not replace impact-rated glass (HVHZ) or perform full window unit replacement. Standard single-pane glass starts around $180. Double-pane insulated glass runs $280 – $450 depending on size.",
      "Does not include impact-rated or HVHZ-certified glass. For impact glass, we refer to licensed Florida contractors."
    ],
    bodyEs: [
      "Reemplazamos vidrios solo en marcos existentes. No reemplazamos vidrios con clasificación de impacto (HVHZ) ni realizamos reemplazo completo de unidades de ventana. Vidrio estándar de una sola capa comienza alrededor de $180. Vidrio aislante de doble capa cuesta $280 – $450 según el tamaño.",
      "No incluye vidrios con clasificación de impacto o certificados HVHZ. Para vidrios de impacto, referimos a contratistas con licencia en Florida."
    ]
  },
  {
    key: "weatherstripping",
    bodyEn: [
      "Weatherstripping replacement stops drafts, water intrusion, and noise. We replace worn seals, door sweeps, and threshold caulking. Most single window or door openings run $60 – $95. Whole-home weatherstripping packages are quoted on-site based on the number of openings."
    ],
    bodyEs: [
      "El reemplazo de burletes detiene corrientes de aire, filtraciones de agua y ruido. Reemplazamos sellos gastados, umbras de puertas y calafateo de umbrales. La mayoría de aberturas individuales de ventanas o puertas cuestan $60 – $95. Los paquetes de burletes para toda la casa se cotizan en sitio según el número de aberturas."
    ]
  },
  {
    key: "maintenance",
    bodyEn: [
      "Our annual maintenance plan includes: full track and frame cleaning, hardware lubrication, weatherstripping inspection, loose hardware tightening, and a written report on anything needing attention. Single-family home annual maintenance starts at $129. Larger homes or homes with many windows are quoted individually."
    ],
    bodyEs: [
      "Nuestro plan de mantenimiento anual incluye: limpieza profunda de rieles y marcos, lubricación de herrajes, inspección de burletes, ajuste de herrajes sueltos y un informe escrito sobre cualquier elemento que necesite atención. El mantenimiento anual para casa unifamiliar comienza en $129. Casas más grandes o con muchas ventanas se cotizan individualmente."
    ]
  },
  {
    key: "emergency",
    bodyEn: [
      "Post-storm or break-in emergency board-up service starts at $149 for a single opening. Multi-opening or high-rise access may increase cost. We use hurricane-grade plywood and secure with lag screws. This is a temporary protection measure, not a permanent repair."
    ],
    bodyEs: [
      "El servicio de tapiado de emergencia post-tormenta o allanamiento comienza en $149 para una abertura individual. Múltiples aberturas o acceso a gran altura pueden aumentar el costo. Usamos madera contrachapada de grado huracán y aseguramos con tornillos de expansión. Esta es una medida de protección temporal, no una reparación permanente."
    ]
  },
  {
    key: "avoid",
    bodyEn: [
      "Get a written quote before any work begins. Verify the provider is insured and specifies what is included. Be cautious of quotes that seem too low — they often exclude parts, travel, or warranty. Ask whether the diagnostic fee applies to the repair.",
      "For impact-rated or HVHZ work, always use a licensed Florida contractor. Unlicensed repair on permitted work can void warranties and create liability issues. We refer to licensed contractors at no cost when work exceeds our repair scope."
    ],
    bodyEs: [
      "Obtenga una cotización escrita antes de que comience cualquier trabajo. Verifique que el proveedor esté asegurado y especifique qué está incluido. Tenga cuidado con cotizaciones que parecen muy bajas — frecuentemente excluyen partes, traslado o garantía. Pregunte si la tarifa de diagnóstico se aplica a la reparación.",
      "Para trabajos con clasificación de impacto o HVHZ, siempre use un contratista con licencia en Florida. Reparaciones sin licencia en trabajos con permiso pueden anular garantías y crear problemas de responsabilidad. Referimos a contratistas con licencia sin costo cuando el trabajo excede nuestro alcance de reparación."
    ]
  }
];

export const costFaq = [
  {
    qEn: "Why is the diagnostic fee $89?",
    aEn: "The $89 covers travel across Miami-Dade and a thorough on-site assessment. If you proceed with the repair, the $89 is applied to the total. We also offer free phone quotes for straightforward issues.",
    qEs: "¿Por qué la tarifa de diagnóstico es $89?",
    aEs: "Los $89 cubren el traslado por Miami-Dade y una evaluación exhaustiva en sitio. Si procede con la reparación, los $89 se aplican al total. También ofrecemos cotizaciones telefónicas gratuitas para problemas directos."
  },
  {
    qEn: "Do you provide written quotes?",
    aEn: "Yes. Every repair receives a written quote before work begins. No surprises, no hidden fees.",
    qEs: "¿Proporcionan cotizaciones escritas?",
    aEs: "Sí. Cada reparación recibe una cotización escrita antes de comenzar el trabajo. Sin sorpresas, sin cargos ocultos."
  },
  {
    qEn: "Do you replace impact-rated glass?",
    aEn: "No. We replace standard glass in existing frames only. For impact-rated glass replacement, we refer to licensed Florida contractors at no cost.",
    qEs: "¿Reemplazan vidrios con clasificación de impacto?",
    aEs: "No. Solo reemplazamos vidrios estándar en marcos existentes. Para reemplazo de vidrios con impacto, referimos a contratistas con licencia en Florida sin costo."
  }
];

export const costServiceLinks = [
  { labelEn: "Sliding Door Repair", labelEs: "Reparación de Puertas Corredizas", to: "/sliding-door-repair/" },
  { labelEn: "Glass Replacement", labelEs: "Reemplazo de Vidrios", to: "/glass-replacement/" },
  { labelEn: "Window Hardware Repair", labelEs: "Reparación de Herrajes", to: "/window-hardware-repair/" },
  { labelEn: "Weatherstripping & Sealing", labelEs: "Burletes y Sellado", to: "/weatherstripping-sealing/" },
  { labelEn: "Window Cleaning & Maintenance", labelEs: "Limpieza y Mantenimiento", to: "/window-cleaning-maintenance/" },
  { labelEn: "Emergency Board-Up", labelEs: "Tapiado de Emergencia", to: "/emergency-board-up/" }
];

export const costMaintenanceItems = [
  { en: "Track and frame deep cleaning", es: "Limpieza profunda de rieles y marcos" },
  { en: "Hardware lubrication and tightening", es: "Lubricación y ajuste de herrajes" },
  { en: "Weatherstripping condition check", es: "Inspección de condición de burletes" },
  { en: "Roller and lock operation test", es: "Prueba de operación de rodillos y cerraduras" },
  { en: "Written condition report", es: "Informe escrito de condición" }
];